import AuthService from '../../../service/auth.js'
export default {
  'data': function () {
    return {
      user: AuthService.state
    }
  },
  'created': function () {
  },
  'mounted': function () {
  },
  'methods': {

  }
}



// WEBPACK FOOTER //
// ./src/component/area-riservata/area-riservata-home/area-riservata-home.js